import type { ClusterPeriod, OverlappingPeriod } from '@atlassian/eoc-schedule-common';

import type { MergedPeriodResponse, OverlappingPeriodResponse } from '../../../common/types';

const fromMergedPeriodResponseToClusterPeriod = (
	mergedPeriodResponse: MergedPeriodResponse,
): ClusterPeriod => {
	const {
		startTimeUtcMillis,
		endTimeUtcMillis,
		isTrueStartTime,
		isTrueEndTime,
		periodStartOffsetMillis,
		periodEndOffsetMillis,
		overlappingPeriods,
	} = mergedPeriodResponse;

	const clusterPeriod = {
		id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
		startEpoch: startTimeUtcMillis,
		endEpoch: endTimeUtcMillis,
		isTrueStartTime,
		isTrueEndTime,
		startOffset: periodStartOffsetMillis,
		endOffset: periodEndOffsetMillis,
		overlaps: overlappingPeriods.map(fromOverlappingPeriodResponseToOverlappingPeriod),
	} satisfies ClusterPeriod;

	return clusterPeriod;
};

const fromOverlappingPeriodResponseToOverlappingPeriod = (
	overlappingPeriodResponse: OverlappingPeriodResponse,
): OverlappingPeriod => {
	const {
		startTimeUtcMillis,
		endTimeUtcMillis,
		periodStartOffsetMillis,
		periodEndOffsetMillis,
		overlappingRotations,
		isTrueStartTime,
		isTrueEndTime,
	} = overlappingPeriodResponse;

	const overlappingPeriod = {
		id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
		startEpoch: startTimeUtcMillis,
		endEpoch: endTimeUtcMillis,
		startOffset: periodStartOffsetMillis,
		endOffset: periodEndOffsetMillis,
		overlaps: overlappingRotations,
		isTrueStartTime,
		isTrueEndTime,
	} satisfies OverlappingPeriod;

	return overlappingPeriod;
};

export { fromMergedPeriodResponseToClusterPeriod };
